const getMmaInMsanPlacementBaseStyles = () => ({
  placementCard: undefined,
  placementImageContainer: undefined,
  placementTextContainer: undefined,
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementShortHeadline: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementBusinessNameWithAdsLabel: undefined,
});

export const getResponsiveMmaInMsanWideImage191x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  placementTextContainer: {
    padding: 10,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
    maxWidth: '-webkit-fill-available',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 18,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },
});

export const getResponsiveMmaInMsanMSEdgeSingleCarousel178x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  placementImageContainer: {
    position: 'relative',
  },

  placementCard: {
    '&:hover $placementGradient': {
      height: '480px !important',
      top: -100,
    },
  },

  // overrides
  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
    fontSize: 10,
    lineHeight: '16px',
    color: '#bebebe',
  },

  placementGradient: {
    display: 'block',
    width: '100%',
    height: '220px !important',
    top: 40,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementShortHeadline: {
    fontWeight: '200',
    fontSize: 28,
    lineHeight: '33.99px',
    color: 'white',
    width: 590,
    height: 73,
    marginBottom: 20,

    '& .multi-line-processed-text': {
      position: 'absolute',
      bottom: 30,
    },
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      color: '#fff !important',
      opacity: 0.7,
      border: '.5px solid hsla(0,0%,100%,.3) !important',
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },
});

export const getResponsiveMmaInMsanMSNInArticle150x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    background: '#fff',
  },

  placementTextContainer: {
    padding: 10,
    // height: 98,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },
});

export const getResponsiveMmaInMsanMSNSmallHeadline133x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    height: 90,
    background: '#fff',
    overflow: 'unset !important',
    '& .card-parent': {
      '& .placement-card-content': {
        flexDirection: 'row !important',
        border: 'none !important',
        height: 90,
      },
    },
  },

  placementImageContainer: {
    float: 'left',
    width: 100,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 52,
    margin: '4px 8px 0 0',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },
});

export const getResponsiveMmaInMsanSquareImage1x1Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    height: 90,
    background: '#fff',
    '& .card-parent': {
      '& .placement-card-content': {
        flexDirection: 'row !important',
        height: 90,
      },
    },
  },

  placementImageContainer: {
    float: 'left',
    width: 80,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 45,
    margin: '8px 8px 0 0',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },
});
